export const COLORS = {
  ICON_HOVER: '#808080',
  ICON_ACTIVE: '#595959',
  TOOLTIP_COLOR:"#666",
  CONTRAST_WCAG_BORDER:'#4E4E4E',
  BLUE_WCAG_BORDER:'#4050C6',
  BLACK:'#000000',
  WHITE:'#FFFFFF',
}

export default COLORS;